export default "__VITE_ASSET__w7ZXDiVirbsrkUKYsLlIvA__"